define([
  "client/template",
  "utils/persistedsourceinfo",
  "model/persisted_collection",
  "service/stub",
  "client/application",
  "backbone",
  "underscore",
  "jquery",
  "i18n/i18n",
  "api/v2/common",
  "api/v2/persisted",
  "service/channel",
  "service/channels",
  "api/v2/resources",
  "client/resourceinfo",
  "moment"
], function(
  Template,
  PersistedSourceInfo,
  PersistedCollection,
  Stub,
  Application,
  Backbone,
  _,
  $,
  i18n,
  Common,
  Persisted,
  Channel,
  Channels,
  Resources,
  ResourceInfo,
  moment
) {

  var AlertModel = Backbone.Model.extend({

    defaults: {
      alertBase: "weekly"
    },

    parse: function (atts) {
      var properties = Common.mapByPluck(atts && atts.property, "key");

      if (!atts.data) atts.data = "{}";
      if (atts && properties) {

        var link = window.location.origin + window.location.pathname + "?emailalert=" + atts.path.join("-");

        var searchModel = JSON.parse(atts.data);
        var userQuery = searchModel && 
                        searchModel.user && 
                        searchModel.user.query && 
                        searchModel.user.query.and && 
                        searchModel.user.query.and[0] &&
                        searchModel.user.query.and[0].unparsed;
        var owner = atts.owner;

        var referenced_notification = properties.referenced_notification && (properties.referenced_notification.reference_value || properties.referenced_notification.value);
        var title = properties && properties.name && properties.name.value;
        var groupTag = properties && properties.group_tag && properties.group_tag.value;
        var created = i18n("moments_ago");

        if (atts.created) {
          created = moment(atts.created).format('LLL');
        } else if (properties && properties.created && properties.created.value) {
          created = properties.created.value;
        }
        
        var frequency = atts.path[1];
        var searchTab;
        var activeFilters = [];

        var queryData = JSON.parse(atts.data);
        if (queryData && queryData.source_context && queryData.source_context.constraints) {
          var searchTabConstraint = _.find(queryData.source_context.constraints, function(constraint){ return constraint.id === "view" ; });
          if (searchTabConstraint) {
            searchTab = searchTabConstraint.name;
          } 
        }

        if (queryData && queryData.user && queryData.user.constraints.length) {
          var userConstraints = queryData.user.constraints;
          _.each(userConstraints, function(constraint) { 
            _.each(constraint.filter_base, function(filter) {
              var dateSplitt = filter.id.split('.');
              var reg = new RegExp('^[0-9]+$');
              if (reg.test(dateSplitt[0])) {
                activeFilters.push(dateSplitt.join(' '));
              } else {
                activeFilters.push(filter.id);
              }
            });
          });
          
          activeFilters = activeFilters.join(", ");
        } else {
          activeFilters = "No Filters";
        }

        return {
          id: atts.path.join("/"),
          path: atts.path,
          query: JSON.parse(atts.data),
          description: properties.description.value,
          link: link,
          groupTag: groupTag || i18n("general"),
          userquery: userQuery,
          owner: owner,
          frequency: frequency,
          referenced_notification: referenced_notification,
          created: created,
          searchTab: searchTab,
          activeFilters: activeFilters
        };
      }
    },

    toJSON: function() {
      var atts = this.attributes;
      var path = atts.path;
      if (!path) {
        path = ["emailalert", atts.alertBase];
      }

      var owner = atts.owner;

      var parsedObj = {
        path: path,
        data: JSON.stringify(atts.query),
        owner: owner,
        property: [{
          key: "description",
          value: atts.description
        },{
          key: "group_tag",
          value: atts.groupTag
        },{
          key: "created",
          value: atts.created
        }
      ]
      };

      if (atts.referenced_notification) {
        parsedObj.property.push({"key": "referenced_notification", "value": atts.referenced_notification})
      }

      return parsedObj;
    },

    getOrderBy: function() {
      if (this.attributes && this.attributes.query && this.attributes.query.orderby)
        return this.attributes.query.orderby;
      return null;
    }
  });

  var AlertCollection = PersistedCollection.extend({
    model: AlertModel,
    usePaths: true,

    initialize: function (unused, options) {
      options = options || {};
      options.serviceStub = options.serviceStub || new Stub({path: "persistedresources"});
      PersistedCollection.prototype.initialize.apply(this, arguments);
      this.path = options.path;
      this.property = options.property;
      this.owner = options.owner;
    },

    parse: function(response) {
      return response.persisted_resources;
    },

    sort_key: "frequency",

    comparator: function(item) {
      return item.get(this.sort_key);
    },

    sortByAttr: function(attrName) {
      this.sort_key = attrName;
      this.sort();
    }
  });

  var GlobalAlertedSearchesModel = Backbone.Model.extend({

    defaults: {
      alertBase: ""
    },

    parse: function(atts) {
      var properties = Common.mapByPluck(atts && atts.property, "key");
      if (atts && properties && atts.data.length) {

        //TODO client url
        var link = window.location.origin + window.location.pathname + "?emailalert=" + atts.path.join("-");

        return {
          id: atts.path.join("/"),
          path: atts.path,
          data: JSON.parse(atts.data),
          description: properties.description.value,
          name: properties.name && properties.name.value,
          link: link,
          enabled: properties && properties.enabled && properties.enabled.value
        };
      }
    },

    toJSON: function() {
      var atts = this.attributes;
      var path = atts.path;

      return {
        path: path,
        data: JSON.stringify(atts.data),
        property: [{
          key: "name",
          value: atts.name
        },{
          key: "description",
          value: atts.description
        },{
          key: "enabled",
          value: atts.enabled || "true"
        }]
      };
    },

    getOrderBy: function() {
      if (this.attributes && this.attributes.query && this.attributes.query.orderby)
        return this.attributes.query.orderby;
      return null;
    }
  });

  var GlobalAlertCollection = PersistedCollection.extend({
    model: GlobalAlertedSearchesModel,
    usePaths: true,

    initialize: function (unused, options) {
      options = options || {};
      options.serviceStub = options.serviceStub || new Stub({path: "persistedresources"});
      PersistedCollection.prototype.initialize.apply(this, arguments);
      this.path = options.path;
      this.property = options.property;
      this.owner = options.owner;
    },

    parse: function(response) {
      return response.persisted_resources;
    },

    sort_key: "frequency",

    comparator: function(item) {
      return item.get(this.sort_key);
    },

    sortByAttr: function(attrName) {
      this.sort_key = attrName;
      this.sort();
    }
  });

  var EmailAlertsModel = Backbone.Model.extend({

    initialize: function () {
      var that = this;

      this.persisted = new Persisted({ channels: this.get("channel") });

      // TODO: register change listener instead? We could get notified, when the information changes
      var schemaAvailablePromise = this.get("serviceInfo").persistedCollectionSchemaAvailable(["emailalert"], this.get("channel"));
      schemaAvailablePromise.done(function (schemaAvailable) {
        that.set("available", schemaAvailable);
      });
    },

    getAlertWithPath: function (path, callback, errback, options) {
      if (!_.isArray(path)) {
        path = path.split( options && options.splitSign || "-");
      }
      // TODO: parse path?
      var that = this;
      var emailAlert = this.persisted.resources(path);
      emailAlert.fetch({
        success: function(response) {
          callback(that.parseEmailAlert(response && response.models && response.models.length === 1 && response.models[0] ));
        },
        error: errback
      });
    },

    getFrequency: function (path, callback, errback) {
      var that = this;
      if (!_.isArray(path)) path = path.split("/");
      // TODO: parse path?
      var frequency = this.persisted.collections(path);
      frequency.fetch({
        success: function(response) {
          if (response && response.models && response.models.length) {
            that.set("frequency", new Backbone.Collection(response.models))
            callback(response.models)
          } else {
            errback;
          }
        },
        error: errback
      });
    },

    getUser: function (path, callback, errback) {
      var that = this;
      if (!_.isArray(path)) path = path.split("/");
      // TODO: parse path?
      var owner = this.get("serviceInfo").userSourceInfo.get("user_name");
      var user = this.persisted.resources(path);
      user.owner = owner;
      this.set("user", user);

      this.get("user").fetch({
        success: function(response) {
          if (response && response.models && response.models[0]) {
            that.set("user", response.models[0])
            callback(response.models)
          } else {
            errback;
          }
        },
        error: errback
      });
    },

    getACL: function (path, callback, errback) {
      var that = this;
      if (!_.isArray(path)) path = path.split("/");
      // TODO: parse path?
      var acl = this.persisted.collections(path);
      acl.fetch({
        success: function(response) {
          if (response && response.models && response.models[0]) {
            var acl_model = response.models[0];
            that.set("acl", acl_model);
            callback(response.models)
          } else {
            errback;
          }
        },
        error: errback
      });
    },

    getSchemaAvailabilityByPath: function (path) {
      this._schemas = this._schemas || {};
      if (this._schemas[path]) return this._schemas[path];
    },

    getSchemaByPath: function (path, application, callback, errback) {
      /* if is available return schema */
      var schema = this.getSchemaAvailabilityByPath(path);
      if (schema) {
        callback(schema)
      } else {
        var that = this;
        if (!_.isArray(path)) path = path.split("/");
        // TODO: parse path?
        var schemaByPath = this.persisted.schema(path);
        schemaByPath.fetch({
          success: function(response, schema) {
            if (schema && schema.schemas && schema.schemas[0]) {
              var schema = schema.schemas[0];
              that._schemas[path] = schema;
              callback(schema);
            } else {
              errback;
            }
          },
          error: errback
        });
      }
    },

    getAlerts: function (options, callback, errback) {
      var that = this;
      var alertCollection = new AlertCollection(null, {
          channels: this.get("channel"),
          appid: options.application.appid,
          path: options.path,
          owner: options.owner
      });
      this.set("alerts", alertCollection);

      this.get("alerts").fetch({
        success: function(response) {
          callback(that.parseFetchedAlert(response && response.models));
        },
        error: errback
      });
    },

    getAlertPresets: function (options, callback, errback) {
      var that = this;
      var alertCollection = new GlobalAlertCollection(null, {
        channels: this.get("channel"),
        appid: options.application.appid,
        path: options.path,
        property: [{
          "key": "enabled",
          "value": "true"
        }]
      });
      this.set("alert_presets", alertCollection);

      this.get("alert_presets").fetch({
        success: function(response) {
          callback(that.parseFechedAlertPresets(response && response.models));
        },
        error: errback
      });

    },

    select: function (select) {
      return this.persisted.resources(["emailalert"]);
    },

    parseEmailAlert: function (model) {
      if (!model) return null;
      model.set("data", JSON.parse(model.get("data")));
      return model;
    },

    parseFetchedAlert: function (models) {
      //todo?
      return models;
    },

    parseFechedAlertPresets: function (models) {
      //todo?
      return models;
    }

  });

  var Models = {};
  return Models = {
    AlertModel: AlertModel,
    AlertCollection: AlertCollection,
    GlobalAlertedSearchesModel: GlobalAlertedSearchesModel,
    GlobalAlertCollection: GlobalAlertCollection,
    EmailAlertsModel: EmailAlertsModel
  }

});